import { VISI_PENDING_STATE_KEY } from "./constants";
import { readPendingRecord } from "./utils";

export const getVisiPendingState = () =>
  readPendingRecord(VISI_PENDING_STATE_KEY);
